import React from 'react';
import './Home.css';
import Banner from './Banner'
import Card from './Card'

// ES7 snippets to do 'rfce'

function Home() {
    return (
        <div className='home'>
            <Banner />

            <div className='home__section'>
                <Card
                    src="https://a0.muscache.com/im/pictures/4a2f688e-0b33-4feb-932f-494b9a37348c.jpg?im_w=720"
                    title="Online Experiences"
                    description="Unique activities we can do together, led by a world of hosts."
                />
                <Card
                    src="https://a0.muscache.com/im/pictures/15159c9c-9cf1-400e-b809-4e13f286fa38.jpg?im_w=720"
                    title="Unique stays"
                    description="Spaces that are more than just a place to sleep."
                />
                <Card
                    src="https://a0.muscache.com/im/pictures/fdb46962-10c1-45fc-a228-d0b055411448.jpg?im_w=720"
                    title="Entire homes"
                    description="Comfortable private places, with room for friends or family."
                />
            </div>
            <div className='home__section'>
                <Card
                    src="https://media.nomadicmatt.com/2019/airbnb_breakup3.jpg"
                    title="3 Bedroom Flat in Bournemouth"
                    description="Superhost with a stunning view of the beachside in Sunny Bournemouth"
                    price="₹1300/night"
                />
                <Card
                    src="https://thespaces.com/wp-content/uploads/2017/08/Courtesy-of-Airbnb.jpg"
                    title="Penthouse in London"
                    description="Enjoy the amazing sights of London with this stunning penthouse"
                    price="₹3500/night"
                />
                <Card
                    src="https://media.nomadicmatt.com/2018/apartment.jpg"
                    title="1 Bedroom apartment"
                    description="Superhost with great amenities and a fabolous shopping complex nearby"
                    price="₹700/night"
                />
            </div>
            <div className='home__section'>
                <Card
                    src="https://a0.muscache.com/im/pictures/22752b48-d81e-4401-8d96-2b5037903289.jpg"
                    title="Silverene Penthouse Studio"
                    description="Superhost with a stunning view of the beachside in Sunny Bournemouth"
                    price="₹1300/night"
                />
                <Card
                    src="https://a0.muscache.com/im/pictures/a43c9149-07c4-4a84-8859-330b1eadbf6b.jpg"
                    title="Burj Khalifa & Canal view"
                    description="15 minutes walk to Dubai Mall & Burj Khalifa. Excellent Burj Khalifa & Lake view from balcony."
                    price="₹50500/night"
                />
                <Card
                    src="https://a0.muscache.com/im/pictures/e15cb215-dc8e-40eb-9a70-6f036fbc9a1d.jpg"
                    title="Endless Summer - Netflix, Pool and shopping"
                    description="Whether your in the mood for Outdoor or indoor experiences, our Cosy Studio is Perfectly situated in the heart of Downtown Dubai"
                    price="₹5200/night"
                />
            </div>
        </div>
    )
}

export default Home
